import $ from 'jquery';
require('jquery-validation');

$.validator.addMethod('postcodeCheck', (value) => {
    const regexp = /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/i;

    return regexp.test(value);
}, 'Please enter a valid UK postcode');

const defaultOptions = {
    submitHandler: (form) => {
        form.submit();
    },

    errorClass: 'fa-input-field--error',

    errorPlacement: () => {},

    highlight: (element, errorClass, validClass) => {
        const $element = $(element);

        $element
            .addClass(errorClass)
            .removeClass(validClass);

        $element.parents('[data-fa-input-field]').addClass(errorClass);
    },

    unhighlight: (element, errorClass, validClass) => {
        const $element = $(element);

        $element
            .removeClass(errorClass)
            .addClass(validClass);

        $element.parents('[data-fa-input-field]').removeClass(errorClass);
    },

    rules: {
        postcode: { postcodeCheck: true }
    }
};

export default class Form {
    constructor(formElement, options = defaultOptions) {
        this.$form = $(formElement);
        this.options = options;
    }

    init() {
        this.$form.validate(this.options);
    }
}



// WEBPACK FOOTER //
// ./libs/validation/customValidation.js